import { render, staticRenderFns } from "./transactionInForm.vue?vue&type=template&id=60e8b427&"
import script from "./transactionInForm.vue?vue&type=script&lang=js&"
export * from "./transactionInForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports